import PropTypes from "prop-types";
import React, { Component } from "react";

class Source extends Component {
  render() {
    var office = this.props.listing.office;
    if (
      office &&
      office.courtesyOf &&
      office.courtesyOf.length > 0 &&
      this.props.show
    ) {
      var courtesies = office.courtesyOf.map(function (item, index) {
        return (
          <span key={index}>
            {item}
            <br />
          </span>
        );
      });
      return (
        <div className="col-sm-16 col-xs-6 col-xxs-16">
          <div id="listing-source">
            Listing Courtesy of:
            <br />
            {courtesies}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

Source.propTypes = {
  listing: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
};

export default Source;



// WEBPACK FOOTER //
// ./src/components/listing-detail/sidebar/source.js